import axios from '@axios'

/**
 * Shared owner/sale/tenant lookup for `autocomplete/v1/users`.
 *
 * ⚠️ The endpoint has no `LIMIT` and no minimum keyword length of its own: a single
 * character matches ~6,000 users and the whole set comes back over the wire on every
 * keystroke, which is what made the owner field on the property form hang and the API
 * error out. `vue-autosuggest` hid it on the screens that set `limit` in their
 * `sectionConfigs` — they still downloaded every row, they just drew six of them.
 *
 * So the guard has to live on this side: nothing is requested below
 * `MIN_USER_KEYWORD` characters, and whatever does come back is trimmed before it
 * reaches the suggestion list.
 *
 * ⚠️ Raising the default here is not enough on its own. `vue-autosuggest` applies its own
 * `sectionConfigs[…].limit` on top, so every screen that sets one has to carry the same
 * number or it silently caps the list again.
 */
export const MIN_USER_KEYWORD = 2

export const searchUsers = async (keyword, limit = 20) => {
  const trimmed = (keyword || '').trim()
  if (trimmed.length < MIN_USER_KEYWORD) return []

  const res = await axios.post('autocomplete/v1/users', { keyword: trimmed })

  return (res.data && res.data.data ? res.data.data : []).slice(0, limit)
}
